export class ShowPrintRoomPropertiesMessage {}